import { CoreState } from '@app/store/core/states';

import { UserState } from './user.state';
import { UserProfileState } from './user-profile.state';
import { UserSettingState } from './user-setting.state';
import { DirectoryState } from './directory.state';
import { UserEmailState } from './user-email.state';
import { UserPermissionState } from './user-permission.state';


export interface UserFeatureState {
  user: UserState;
  userProfile: UserProfileState;
  userSetting: UserSettingState;
  directory: DirectoryState;
  userEmail: UserEmailState;
  userPermission: UserPermissionState
}

export interface State extends CoreState {
  user: UserFeatureState;
}
